import React from 'react';
import PropTypes from 'prop-types';

import { BasketCheckPrice } from './BasketCheckPrice';
import { locales } from './basket-check.locales';

import './basket-check-rows.scss';


export const Total = (props) => {
    const {
        basket: { totals: { total_common_price: totalCommonPrice } },
        locale,
    } = props;

    return (
        <div styleName="basket-check__row">
            <div>
                <p styleName="basket-check__row-total-text">
                    {locales[locale].total}
                </p>
            </div>
            <div>
                <BasketCheckPrice
                    price={totalCommonPrice}
                    type="total"
                />
            </div>
        </div>

    );
};


Total.propTypes = {
    basket: PropTypes.shape({
        totals: PropTypes.shape({
            total_price: PropTypes.number.isRequired,
            delivery_price: PropTypes.number.isRequired,
            referral_amount: PropTypes.number.isRequired,
            total_common_price: PropTypes.number.isRequired,
            discount_amount: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
    locale: PropTypes.string.isRequired,
};
